import { IApplicationState } from '../../types/redux/store';

export const selectPromoSearchTypes = (state: IApplicationState) => state.filters.promoSearchTypes;
